import { useParams, useNavigate } from "react-router-dom";
import Loader from "../Components/Loader";
import { jwtVerify } from "jose";
import { useState, useEffect, useContext } from "react";
import GeneralContext from "../utils/generalContext";
import { logginIn } from "./login_util";
import axios from "axios";

const LogSubmit = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const { user, destroySession, global } = useContext(GeneralContext);

    const [payload, setPayload] = useState(null);
    const [processed, setProcessed] = useState(false);

    useEffect(() => {
      if(user?.user && !processed){
        destroySession();
      }
    }, [user?.user, processed])
   
    useEffect(() => {
        const secretString = process.env.REACT_APP_CURSOS_SECRET_KEY || 'ccb99d70628efa2b1c840bb4d1c1c46afdafb0f782760d9bcbe4ea7bd79c456e';
        const secret = new TextEncoder().encode(secretString);
        
        async function verifyToken() {
            try {
                if(!token) throw new Error("No token provided");
                const { payload: JWTPayload } = await jwtVerify(token, secret);
                setPayload(JWTPayload); // store payload in state
            } catch (err) {
                console.error("Token verification failed:", err);
                navigate('/login');
            }
        }

        verifyToken();
    }, [token, navigate]);

    useEffect(() => {
        if(payload && payload.data && payload.data.matricula_academica && user && global) {
            const submit = async () => { 
                let url = `${global.domain}v3-api/v3/login_direct.json`;
                console.log({url})
                let res = await axios.post(url, {
                    username: payload.data.matricula_academica,
                    password: payload.data.token
                }).catch(function (error) {
                    console.error(error.message)
                });
        
                if (res && res.data) {
                    localStorage.setItem('user', JSON.stringify(res.data));
                    const paymentToken = (res?.data?.franchise?.paymentMethods ?? []).find(payment => payment.actionname === 'quentli')?._matchingData?.FranchisePaymentmethods?.value ?? undefined;
                    localStorage.setItem('QuentliToken', paymentToken);
                    setProcessed(true);
                    user.setUser(res.data);
                    navigate('/');
                } else {
                    // Optional: handle failed login visually or redirect to login.
                    navigate('/login');
                }
            }
            submit();
        }
    }, [payload])

    return (
        <div>
            <Loader />
        </div>
    )
}

export default LogSubmit;